import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { KeyboardService } from '../components/keyboard/keyboard.service';

@Component({
  selector: 'app-dialog-container',
  templateUrl: './dialog-container.component.html',
  styleUrls: ['./dialog-container.component.sass'],
})
export class DialogContainerComponent implements OnInit {
  @Input()
  showKeyboardButton = true;
  @Input()
  showHelpButton = true;
  @Input()
  enableScroll = false;
  @Input()
  maxHeight = 'auto';
  @Input()
  scrollClass = '';
  @Input()
  noPadding = false;
  @Output()
  onClickHelpButton: EventEmitter<any> = new EventEmitter();

  constructor(public keyboardService: KeyboardService) { }

  ngOnInit(): void { }
}
